// This ensures that the icon CSS is loaded immediately before attempting to render icons
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";

// Supports weights 300-800
import '@fontsource-variable/open-sans/wght.css';

// Supports weights 300-700
import '@fontsource-variable/quicksand/wght.css';

import '@fontsource/caprasimo';

import "./src/sass/style.scss";

// Prevent fontawesome from dynamically adding its css since we did it manually above
config.autoAddCss = false;

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0);

  return false;
};
